import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/icontfont/iconfont.css";

import "@/assets/css/reset.css";
import "@/assets/css/index.css";
import "@/assets/css/swiper.min.css";
import "nprogress/nprogress.css";
// 引入element-ui的样式
import ElementUI, { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/message.css";
import { getApiBaseUrl } from "@/utils/baseUrl.js";

Vue.use(ElementUI);

const MESSAGE_DEFAULTS = {
  center: true,
  showClose: true,
  duration: 3500,
  customClass: "global-message-prominent",
};

function showMessage(options) {
  if (typeof options === "string") {
    options = { message: options };
  }
  return Message({ ...MESSAGE_DEFAULTS, ...options });
}

["success", "warning", "info", "error"].forEach((type) => {
  showMessage[type] = (options) => {
    if (typeof options === "string") {
      options = { message: options };
    }
    return showMessage({ type, ...options });
  };
});

Vue.prototype.$message = showMessage;
Vue.config.productionTip = false;
Vue.prototype.$globalUrl = getApiBaseUrl();
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
